import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { localDate } from '@/platform/lib/utils';
import {
    Button,
    Container,
    FilterBarDropdown,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { ArrowDownTrayIcon, PlusIcon } from '@heroicons/react/24/outline';
import { Link, usePage } from '@inertiajs/react';

const IndexView = () => {
    const { auth, quickscans } = usePage().props;
    const { filters, updateFilters, isSorted } = useFilters(['quickscans']);

    const customer = auth?.customer;
    const base = `/customers/${customer?.id}/services/quickscans`;

    const entities = (customer?.entities || []).map(entity => ({
        id: entity.id,
        name: entity.number ? `${entity.number}. ${entity.name}` : entity.name,
    }));

    const entityLabel =
        entities.find(entity => entity.id === filters?.entity_id)?.name ||
        'Entiteit';

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Quickscans (${quickscans?.meta?.total || 0})`}
                >
                    <Button
                        variant='primary'
                        as={Link}
                        href={`${base}/create?entity_id=${filters?.entity_id || ''}`}
                    >
                        <PlusIcon className='size-5' />
                        Nieuwe Quickscan
                    </Button>
                </SegmentHeader>
                <SegmentContent>
                    <SearchBarFilter only={['quickscans']}>
                        <FilterBarDropdown
                            label={entityLabel}
                            options={entities}
                            value={filters?.entity_id || ''}
                            onChange={value =>
                                updateFilters('entity_id', value)
                            }
                        />
                    </SearchBarFilter>

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell
                                    sorted={isSorted('type')}
                                    onClick={() =>
                                        updateFilters('sort', 'type')
                                    }
                                >
                                    Type
                                </TableHeaderCell>
                                <TableHeaderCell
                                    sorted={isSorted('created_at')}
                                    onClick={() =>
                                        updateFilters('sort', 'created_at')
                                    }
                                >
                                    Aangemaakt op
                                </TableHeaderCell>
                                <TableHeaderCell
                                    className='w-px'
                                    textAlign='right'
                                />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {quickscans?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={3} />
                            )}

                            {quickscans?.data?.map(quickscan => (
                                <TableRow key={quickscan.id}>
                                    <TableCell>
                                        <Link
                                            href={`${base}/${quickscan.id}/edit`}
                                        >
                                            {quickscan.type}
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        {localDate(quickscan.created_at)}
                                    </TableCell>
                                    <TableCell
                                        className='w-px'
                                        singleLine
                                        textAlign='right'
                                    >
                                        <Button
                                            as='a'
                                            href={`${base}/${quickscan.id}/download`}
                                            target='_blank'
                                            aria-label={`Download quickscan ${quickscan.type}`}
                                        >
                                            <ArrowDownTrayIcon className='size-5' />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>
                <SegmentFooter>
                    <CustomPagination
                        meta={quickscans?.meta}
                        only={['quickscans']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
